import { Box, Flex, Text } from '@chakra-ui/react';
import * as React from 'react';

import type { PointOfView } from './message-preview';

export interface MessageIncomingProps {
  id: string;
  message: React.ReactNode;
  pointOfView?: PointOfView;
}

export const MessageIncoming: React.FC<MessageIncomingProps> = ({
  id,
  message,
  pointOfView = 'contact',
}) => {
  const isContactView = pointOfView === 'contact';

  return (
    <Flex key={id} justifyContent="flex-end" mb={3}>
      <Box
        bg={isContactView ? 'navy.solid' : 'bg.surface.lv0'}
        color={isContactView ? 'navy.contrast' : 'fg'}
        p={3}
        borderRadius="md"
        maxW="85%"
      >
        <Text fontSize="sm" whiteSpace="pre-wrap">
          {message}
        </Text>
      </Box>
    </Flex>
  );
};

export default MessageIncoming;
